<script setup>
import { v4 as uuidv4 } from 'uuid'

// model
const model = defineModel()

// props
const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
  id: {
    type: String,
    default: () => uuidv4()
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  rows: {
    type: Number,
    default: 10,
  },
  maxlength : {
    type: String
  },
  label : {
    type : String
  }


})

</script>

<template>
  <label v-if="props.label">{{ props.label }}</label>
  <textarea v-model="model" class="form-control" :id="id" :rows="rows" :disabled="disabled"></textarea>
  <span v-if="props.maxlength">최대 입력가능한 수는 {{ props.maxlength }}자입니다.</span>  
  <span v-if="props.maxlength">현재 입력한 수: {{ props.modelValue ? [...props.modelValue].length : 0 }}</span>
</template>